import * as stylex from "@stylexjs/stylex";
import { springConfigs } from "charts/lib/motion";
import { motion } from "framer-motion";
import { useRTL } from "../../../../hooks";
import { getContrastText } from "../../../../lib/colorManipulator";
import * as M from "../../../../materials";
import { breakpoints } from "../../../../materials/consts.stylex";
import { typography } from "../../../../materials/typography.stylex";
const styles = {
    root: {
        kfzvcC: "x47corl",
        k1xSpc: "x78zum5",
        kjj79g: "x1qughib",
        khDVqt: "xuxw1ft",
        kmVPX3: "xxzb6uj",
        kaIpWk: "x1cum3z5",
        $$css: true
    },
    ltr: {
        ksoyAI: "xzt5al7",
        $$css: true
    },
    rtl: {
        ksoyAI: "xzyj77d",
        $$css: true
    }
};
export default function Tooltip({ label, value, color }) {
    const isRTL = useRTL();
    return <motion.div {...stylex.props(typography.meta, styles.root, isRTL ? styles.rtl : styles.ltr)} style={{
        color: getContrastText(color, {
            light: M.whiteText,
            dark: M.blackText
        }),
        backgroundColor: color
    }} initial={{
        opacity: 0
    }} animate={{
        opacity: 1
    }} transition={springConfigs.gentle}>
      <span>{label}</span>
      <span {...{
        0: {
            className: "x1iog12x xagiob3"
        },
        1: {
            className: "xl010v5 xxcm7zt"
        }
    }[!!isRTL << 0]}>{value}</span>
    </motion.div>;
}
